export default {"src":"/_next/static/media/tiktok.12863ba4.svg","height":18,"width":17,"blurWidth":0,"blurHeight":0};